import * as _ from 'lodash'
import Report from '../model/Report'
import ReportGroup from '../model/ReportGroup'
import { reducerWithInitialState } from 'typescript-fsa-reducers'
import { LoadReportList } from '../pages/ReportsList/actions/LoadReportList'
import { LoadReportGroupList } from '../pages/ReportsList/actions/LoadReportGroupList'
import { Failure, Success } from 'typescript-fsa'
import { ReplaceReport } from '../pages/ReportsList/actions/ReplaceReport'
import { DeleteReport } from '../pages/ReportsList/actions/DeleteReport'
import { AddReport } from '../pages/AddReport/actions/AddReport'
import NewReport from '../model/NewReport'

export type ReportState = {
  reports: Report[]
  reportsLoading: boolean
  errorMessage: string
  reportGroupsLoading: boolean
  reportGroups?: _.Dictionary<ReportGroup[]>
  reportGroupsErrorMessage: string
}

export const reportInitialState = {
  reportsLoading: true,
  reportGroupsLoading: true,
  reports: [],
  errorMessage: '',
  reportGroupsErrorMessage: ''
}

let replaceReportsInList = (reports: Report[], reportId: number, newReport: Report) => {
  let index = reports.findIndex(r=>r.id=reportId);
  if(index < 0){
    reports = reports.concat(newReport);
  } else {
    reports.splice(index, 1, newReport);
  }
  return reports;
};

export const reportReducer = reducerWithInitialState<ReportState>(reportInitialState)
  .case(DeleteReport.started, (state: ReportState) => ({
    ...state,
    reportsLoading: true
  }))
  .case(
    DeleteReport.done,
    (state: ReportState, payload: Success<{ market: string; report: Report }, Report[]>) => ({
      ...state,
      reports: payload.result,
      reportsLoading: false,
      errorMessage: ''
    })
  )
  .case(
    DeleteReport.failed,
    (state: ReportState, code: Failure<{ market: string; report: Report }, string>) => ({
      ...state,
      errorMessage: `Error deleting report: ${code.error}`,
      reportsLoading: false
    })
  )
  .case(AddReport.started, (state: ReportState) => ({
    ...state,
    reportsLoading: true
  }))
  .case(
    AddReport.done,
    (
      state: ReportState,
      payload: Success<
        { market: string; reportGroup: string; report: NewReport },
        Report[]
      >
    ) => ({
      ...state,
      reports: payload.result,
      reportsLoading: false,
      errorMessage: ''
    })
  )
  .case(
    AddReport.failed,
    (
      state: ReportState,
      code: Failure<{ market: string; reportGroup: string; report: NewReport }, string>
    ) => ({
      ...state,
      errorMessage: `Error adding report: ${code.error}`,
      reportsLoading: false
    })
  )
  .case(ReplaceReport.started, (state: ReportState) => ({
    ...state,
    reportsLoading: true
  }))
  .case(
    ReplaceReport.done,
    (
      state: ReportState,
      payload: Success<{ market: string; report: Report; file: File }, Report>
    ) => ({
      ...state,
      reports: replaceReportsInList(state.reports, payload.params.report.id, payload.result),
      reportsLoading: false,
      errorMessage: ''
    })
  )
  .case(
    ReplaceReport.failed,
    (
      state: ReportState,
      code: Failure<{ market: string; report: Report; file: File }, string>
    ) => ({
      ...state,
      errorMessage: `Error replacing report: ${code.error}`,
      reportsLoading: false
    })
  )
  .case(LoadReportGroupList.started, (state: ReportState, dummy: null) => ({
    ...state,
    reportGroupsLoading: true
  }))
  .case(LoadReportGroupList.done, (state: ReportState, payload: Success<null, ReportGroup[]>) => ({
    ...state,
    reportGroups: _.groupBy(payload.result.filter(r => r.key !== 'all'), 'marketKey'),
    reportGroupsLoading: false,
    reportGroupsErrorMessage: ''
  }))
  .case(LoadReportGroupList.failed, (state: ReportState, code: Failure<null, string>) => ({
    ...state,
    reportGroupsErrorMessage: `Error loading report group list: ${code.error}`,
    reportGroupsLoading: false
  }))
  .case(LoadReportList.started, (state: ReportState) => ({
    ...state,
    reportsLoading: true
  }))
  .case(
    LoadReportList.done,
    (state: ReportState, payload: Success<{ market: string; reportGroup: string }, Report[]>) => ({
      ...state,
      reports: payload.result,
      reportsLoading: false,
      errorMessage: ''
    })
  )
  .case(
    LoadReportList.failed,
    (state: ReportState, code: Failure<{ market: string; reportGroup: string }, string>) => ({
      ...state,
      errorMessage: `Error loading report list: ${code.error}`,
      reportsLoading: false
    })
  )
